var exports = {
  "x": "footerContainer__wcyzHa",
};

module.exports = exports;
